import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, useWindowDimensions, ActivityIndicator } from 'react-native';
import { get } from 'lodash';
import DynamicFilters from './Filters';
import FilterSummary from './FilterSummary';
import { findMatchingOption } from '../utils/queryParams';

const FilterBar = ({
  filters = {},
  onFiltersChange,
  onRun,
  config = [],
  appliedFilters = {},
  showLoading,
  open,
  setOpen,
  dynamicFilterLoading
}) => {
  const { width } = useWindowDimensions();
  const isSmallScreen = width < 768;

  const handleFiltersChange = updated => onFiltersChange(updated);
  const isRunDisabled = () => { return dynamicFilterLoading; };

  const buildSummary = () => {
    if (!appliedFilters || typeof appliedFilters !== 'object') return {};
    return Object.entries(appliedFilters).reduce((acc, [key, value]) => {
      const selected = get(appliedFilters, key, []);
      if (key === 'topics_filter') {
        const andParts = (selected || [])
          .map(andGroup => {
            const labels = (andGroup || []).map(item => item?.fullLabel || item?.label).filter(Boolean);

            return labels.length > 0 ? labels.join(', ') : null;
          })
          .filter(Boolean);

        if (andParts.length > 0) {
          acc[key] = andParts.join(' and ');
        }

        return acc;
      }

      if (!Array.isArray(selected) || selected.length === 0) return acc;
      acc[key] = selected.map(s => s.fullLabel || s.label).join(', ');
      return acc;
    }, {});
  };

  const summary = buildSummary();
  const selectedFilterKeys = Object.keys(summary);
  if (showLoading) {
    return (
      <View style={styles.loader}>
        <ActivityIndicator size='small' color='#4e5dca' />
      </View>
    );
  }
  return (
    <View style={styles.container}>
      <View style={[styles.summaryRow, isSmallScreen && styles.summaryRowMobile]}>
        <FilterSummary config={config} summary={summary} selectedFilterKeys={selectedFilterKeys} setOpen={setOpen} />
      </View>

      {open && (
        <View style={[styles.modalContainer, isSmallScreen && styles.modalContainerMobile]}>
          <View style={[styles.filtersRow, isSmallScreen ? styles.filtersRowMobile : null]}>
            <View style={[!isSmallScreen && styles.leftColumn]}>
              <DynamicFilters
                filtersConfig={config.filter(f => f.position === 'left')}
                selectedFilters={filters}
                onFiltersChange={handleFiltersChange}
              />
            </View>

            <View style={[styles.column, isSmallScreen && styles.columnMobile]}>
              <DynamicFilters
                filtersConfig={config.filter(f => f.position === 'right')}
                selectedFilters={filters}
                onFiltersChange={handleFiltersChange}
              />
            </View>
          </View>

          <View style={[styles.buttonRow, isSmallScreen && styles.buttonRowMobile]}>
            <TouchableOpacity
              style={[styles.button, styles.resetButton]}
              onPress={() => {
                handleFiltersChange({});
                const cleanUrl = window.location.origin + location.pathname;
                window.location.href = cleanUrl;
              }}>
              <Text style={styles.resetText}>Reset</Text>
            </TouchableOpacity>

            <TouchableOpacity style={[styles.button, styles.runButton, isRunDisabled() && styles.runButtonDisabled]} onPress={onRun} disabled={isRunDisabled()}>
              <Text style={styles.runText}>Run</Text>
            </TouchableOpacity>
          </View>
        </View>
      )}
    </View>
  );
};

export default FilterBar;

const styles = StyleSheet.create({
  loader: {
    height: 51,
    width: '100%',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    zIndex: 1
  },
  container: {
    backgroundColor: '#fff',
    paddingBottom: 10,
    gap: 6
  },
  summaryRow: {
    zIndex: 100
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    zIndex: 1,
    paddingHorizontal: '2%'
  },
  modalContainerMobile: {
    paddingHorizontal: 10,
    width: '100%'
  },
  filtersRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 20,
    borderBottomColor: '#dde1e5',
    borderBottomWidth: 1
  },
  filtersRowMobile: {
    flexDirection: 'column',
    gap: 0
  },
  column: {
    flex: 1,
    paddingRight: '3.5%'
  },
  columnMobile: {
    paddingRight: 0
  },
  leftColumn: {
    flex: 1,
    paddingRight: '3.5%',
    borderRightColor: '#e5e7eb',
    borderRightWidth: 1
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingVertical: 7
  },
  buttonRowMobile: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 8
  },
  button: {
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 10,
    marginLeft: 10,
    maxWidth: 200
  },
  resetButton: { backgroundColor: '#f3f4f6' },
  runButton: { backgroundColor: '#2563eb' },
  runButtonDisabled: { backgroundColor: '#9ca3af' },
  resetText: { color: '#374151', fontWeight: '500', textAlign: 'center' },
  runText: { color: '#fff', fontWeight: '600', textAlign: 'center' }
});
